import React from 'react'
import { mapLanguageToComponentProps } from 'admin/i18n'

import { connect } from 'react-redux'
import { I18nComponentType } from 'admin/i18n-types'
import { formatDateTime } from 'utils/date'
import { Flex } from 'components/styled/containers/flex'
import { Small } from 'components/styled/typography'

interface PersonStateProps {
  state?: string
  lastAccess: Date
  i18n: I18nComponentType
  context: 'jobAd' | 'interview' | 'live'
}

function PersonState({ context, state, lastAccess, i18n }: PersonStateProps) {
  const lastSeen = lastAccess
    ? i18n.personDetails.lastSeen(formatDateTime(lastAccess))
    : i18n.personDetails.notVisited

  const getPersonState = () =>  {
    if (!state) {
      return undefined
    }
    if (state.indexOf('question') > -1 || state === 'networktest') {
      return i18n.personDetails.state.incomplete
    }

    const stateTranslations =
      context === 'live'
        ? i18n.personDetails.liveCandidateState
        : i18n.personDetails.state

    return state in stateTranslations
      ? stateTranslations[state as keyof typeof stateTranslations]
      : undefined
  }

  return (
    <Flex mt="s8">
      <Small fontWeight={600} whiteSpace="pre">
        {state && `${getPersonState()}, `}
      </Small>
      {state && <Small>{lastSeen}</Small>}
    </Flex>
  )
}

export default connect(mapLanguageToComponentProps())(PersonState)
